import React, {useContext} from "react";
import {YearReportData} from "../../../interfaces/RankingsAndLevelsInterfaces";
import styled from "styled-components";
import Colors from "../../../assets/colors/Colors";
import withLoadingAnimation from "../../AnimationWrapper/AnimationWrapper";
import {StyledSkeletonLine} from "../../SkeletonLoader/SkeletonLoaders";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";

import { useTranslation } from "react-i18next";

const FrontCaret = styled.div`
    margin: auto 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 10px solid ${Colors.headerNavigationRed};
    height: 0px;
    cursor: pointer;
`;

const PreviousYearsGipDownloadComponent: React.FC<{text: string, link: string | null}> = ({text, link}) => {
    const downloadURL = link ? link : '';
    if (!downloadURL) {
        return null;
    }

    return (
        <a  href={downloadURL} download target='_blank' rel="noopener noreferrer"
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: 10,
              color: 'black'
            }}
        >
            <FrontCaret />
            <div style={{
              marginLeft: 30,
              fontFamily: 'Mapfre-Black',
              fontSize: 13,
              letterSpacing: 1.3
            }}>
              {text}
            </div>
        </a>
    )
};

const Separator: React.FC = () => {
    return (
        <div style={{marginBottom: 30}}>
            <div style={{flex: 0.15}}/>
            <div style={{flex: 0, borderTop: '1px solid', marginTop: 5, width: 50}}/>
            <div style={{flex: 0.15}}/>
        </div>
    )
};

const DownloadList = (pastYearsReportURL: YearReportData[]) => {
    const { t, i18n } = useTranslation();
    const lng = i18n.language || window.localStorage.i18nextLng || 'es';

    return (
        <React.Fragment>
            {
                pastYearsReportURL
                  .filter(report => {
                    // @ts-ignore
                    return report['download_urls'] && report['download_urls'][lng]
                  })
                  .map((pastReport, index) => {
                    return <PreviousYearsGipDownloadComponent
                      key={index}
                      text={ t('pdfDownload.reports.report', { year: pastReport.year + 1 }) }
                      // @ts-ignore
                      link={ pastReport['download_urls'][lng] || '#' }
                    />
                })
            }
        </React.Fragment>
    )
};


const PastGipDownloadComponent: React.FC<{ pastYearsReportURL?: YearReportData[] }> = ({pastYearsReportURL}) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);
    const { t } = useTranslation();

    return (
        <div style={{width: '75%', marginTop: 30}}>
            <div style={{textAlign: 'start', fontSize: 8, fontFamily: 'Mapfre-Light'}}>
              { t('pdfDownload.reports.description') }
            </div>
            <Separator />

            {
                withLoadingAnimation(
                    DownloadList(pastYearsReportURL || []),
                    <StyledSkeletonLine customStyle={{width: '100%'}} count={3}/>,
                    allDataLoaded
                )
            }
        </div>

    )
};

export default PastGipDownloadComponent;
